import React, { Fragment } from "react"
import { GenericDialog } from "../../components/generic/GenericDialog"
import { Box, Button, Stack, Typography } from "@mui/material";
import { GenericAvatar } from "../../components/generic/GenericAvatar";
import { ACCEPTED, CANCELLED } from "../../enums/statusEnums";
import { toSlug } from "../../helpers/stringHelper";
import useStore from "../../states/store";
import { PAGE_PERMISSIONS } from "../../enums/permissions/permission";

export const CollabRequestUpdateDialog = (props) => {
  const {
    openCollabRequestUpdateDialog,
    handleCloseRequestUpdateDialog,
    collabRequestDetails,
    isCollabRequest = true
  } = props;

  const { CAN_VIEW_CHATS_PAGE } = PAGE_PERMISSIONS;
  const [, { hasPermission }] = useStore();
  const isAccepted = (collabRequestDetails?.status === ACCEPTED);
  const isCancelled = (collabRequestDetails?.status === CANCELLED);
  const requestedTo = collabRequestDetails?.requested_to;
  const requestedBy = collabRequestDetails?.requested_by;

  return (
    <GenericDialog
      width={'780px'}
      title={'Collab Update'}
      openDialog={openCollabRequestUpdateDialog}
      handleClose={handleCloseRequestUpdateDialog}
    >
      <Fragment>
        <Box
          sx={{
            overflowX: 'auto',
            padding: '0px 15px 15px 15px',
            height: isAccepted && { xs: '100%' }
          }}
        >
          <Stack alignItems={'center'} gap={2} mb={3}>
            <GenericAvatar
              size={'128px'}
              location={(isCancelled && isCollabRequest) ? requestedBy?.details?.profile_picture?.location : requestedTo?.details?.profile_picture?.location}
            />
            <Typography
              variant="h5"
              fontWeight={700}
              textAlign={'center'}
            >
              {isCancelled ? (!isCollabRequest ? 'You' : requestedBy?.name) : requestedTo?.name}
              {isCollabRequest && ' has'} {collabRequestDetails?.status} {isCancelled ? 'collab request' : 'your collab invitation'}
            </Typography>
          </Stack>
          {
            isAccepted ? <Fragment>
              <Stack gap={3.5} mb={0.5}>
                <Typography variant="subtitle1">Great News!</Typography>
                <Typography variant="subtitle1">
                  We’re pleased to confirm that {requestedTo?.name} has accepted your invitation to collaborate. We believe you both have a lot to achieve together and that this partnership will be mutually beneficial.
                </Typography>
                {
                  hasPermission(CAN_VIEW_CHATS_PAGE) && <Typography variant="subtitle1">
                    You can now start chatting with {requestedTo?.name} and begin your collaboration.
                  </Typography>
                }
                {/* <Typography variant="subtitle1">
                  Connect with {requestedTo?.name} through the contact details provided below:
                </Typography>
                <Typography variant="subtitle1"><b>Contact Details: </b>{requestedTo?.details?.contact_details}</Typography>
                <Typography variant="subtitle1" fontWeight={700}>Instruction/Requirement Details:</Typography> */}
              </Stack>
              {/* <Typography variant="subtitle1">{requestedTo?.details?.instructions}</Typography> */}
            </Fragment> : <Fragment>
              <Stack gap={3.5} mb={2}>
                <Typography variant="subtitle1">Thank you for extending the collab invitation.</Typography>
                <Typography variant="subtitle1">
                  {
                    (!isCollabRequest && isCancelled) ? <Fragment>
                      You have decided to pull back your collab request to {requestedTo?.name} for now. We totally understand and look forward to any chances to work together down the line.
                    </Fragment> : <Fragment>
                      After careful consideration, {isCancelled ? requestedBy?.name : requestedTo?.name} has reviewed the offer and has {collabRequestDetails?.status} at this time. We encourage you to continue reaching out to other members for future opportunities.
                    </Fragment>
                  }
                </Typography>
                {(isCollabRequest || !isCancelled) ? <Typography variant="subtitle1">Thank you for your understanding.</Typography> : <Typography variant="subtitle1">Feel free to connect with other members for future opportunities.</Typography>}
              </Stack>
            </Fragment>
          }
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} mt={2}>
          {
            isAccepted ?
              <Button
                size="large"
                variant="contained"
                className="longButton"
                onClick={() => hasPermission(CAN_VIEW_CHATS_PAGE)
                  ? window.open(`/chats`, '_blank')
                  : window.open(`/creator?user=${toSlug(requestedTo?.name)}-${requestedTo?.id}`, '_blank')
                }
              >
                {hasPermission(CAN_VIEW_CHATS_PAGE) ? 'Start Chatting' : 'View Profile'}
              </Button>
              : <Button
                size="large"
                variant="contained"
                className="longButton"
                onClick={() => handleCloseRequestUpdateDialog()}
              >
                Got it!
              </Button>
          }
        </Box>
      </Fragment>
    </GenericDialog >
  )
};